// Generated by scripts/gen-cis-levels.mjs. Do not edit by hand.
//
// Which CIS profile a recommendation belongs to, by its title: 1 is in "Level 1 -
// Server", 2 only in "Level 2 - Server", 0 only in a workstation profile.
// Source: ComplianceAsCode/content, controls/cis_ubuntu*.yml, master on 2026-10-15; the 24.04 file last changed in 9fba127e4443
// (Ubuntu 24.04 LTS v1.0.0; Ubuntu 22.04 LTS v2.0.0), BSD-3-Clause, notice in
// licenses/ComplianceAsCode-content-BSD-3-Clause.txt. CIS Benchmarks are the
// property of the Center for Internet Security; only this title-to-level table,
// not any benchmark text, is kept here.
// 0 title(s) the two benchmarks place differently were left out.
export const CIS_LEVEL_BY_TITLE = {
    'ensure /dev/shm is a separate partition': 1,
    'ensure /etc/shadow password fields are not empty': 1,
    'ensure /tmp is a separate partition': 1,
    'ensure a nftables table exists': 1,
    'ensure a single firewall configuration utility is in use': 1,
    'ensure a single time synchronization daemon is in use': 1,
    'ensure access to /etc/issue is configured': 1,
    'ensure access to /etc/issue.net is configured': 1,
    'ensure access to /etc/motd is configured': 1,
    'ensure access to all logfiles has been configured': 1,
    'ensure access to bootloader config is configured': 1,
    'ensure access to the su command is restricted': 1,
    'ensure accounts in /etc/passwd use shadowed passwords': 1,
    'ensure accounts without a valid login shell are locked': 1,
    'ensure actions as another user are always logged': 2,
    'ensure address space layout randomization is enabled': 1,
    'ensure aide is installed': 1,
    'ensure all apparmor profiles are enforcing': 2,
    'ensure all apparmor profiles are in enforce or complain mode': 1,
    'ensure all groups in /etc/passwd exist in /etc/group': 1,
    'ensure all users last password change date is in the past': 1,
    'ensure apparmor is enabled in the bootloader configuration': 1,
    'ensure apparmor is installed': 1,
    'ensure at is restricted to authorized users': 1,
    'ensure audit configuration files group owner is configured': 2,
    'ensure audit configuration files mode is configured': 2,
    'ensure audit configuration files owner is configured': 2,
    'ensure audit log files group owner is configured': 2,
    'ensure audit log files mode is configured': 2,
    'ensure audit log files owner is configured': 2,
    'ensure audit log storage size is configured': 2,
    'ensure audit logs are not automatically deleted': 2,
    'ensure audit tools group owner is configured': 2,
    'ensure audit tools mode is configured': 2,
    'ensure audit tools owner is configured': 2,
    'ensure audit_backlog_limit is sufficient': 2,
    'ensure auditd packages are installed': 2,
    'ensure auditd service is enabled and active': 2,
    'ensure auditing for processes that start prior to auditd is enabled': 2,
    'ensure autofs services are not in use': 1,
    'ensure automatic error reporting is not enabled': 1,
    'ensure avahi daemon services are not in use': 1,
    'ensure bluetooth services are not in use': 1,
    'ensure bogus icmp responses are ignored': 1,
    'ensure bootloader password is set': 1,
    'ensure broadcast icmp requests are ignored': 1,
    'ensure changes to system administration scope (sudoers) is collected': 2,
    'ensure chrony is configured with authorized timeserver': 1,
    'ensure chrony is enabled and running': 1,
    'ensure chrony is running as user _chrony': 1,
    'ensure core dumps are restricted': 1,
    'ensure cramfs kernel module is not available': 1,
    'ensure cron daemon is enabled and active': 1,
    'ensure crontab is restricted to authorized users': 1,
    'ensure cryptographic mechanisms are used to protect the integrity of audit tools': 2,
    'ensure dccp kernel module is not available': 2,
    'ensure default user shell timeout is configured': 1,
    'ensure default user umask is configured': 1,
    'ensure dhcp server services are not in use': 1,
    'ensure discretionary access control permission modification events are collected': 2,
    'ensure dns server services are not in use': 1,
    'ensure dnsmasq services are not in use': 1,
    'ensure events that modify date and time information are collected': 2,
    'ensure events that modify the sudo log file are collected': 2,
    "ensure events that modify the system's mandatory access controls are collected": 2,
    "ensure events that modify the system's network environment are collected": 2,
    'ensure events that modify user/group information are collected': 2,
    'ensure file deletion events by users are collected': 2,
    'ensure filesystem integrity is regularly checked': 1,
    'ensure freevxfs kernel module is not available': 1,
    'ensure ftp client is not installed': 1,
    'ensure ftp server services are not in use': 1,
    'ensure gdm automatic mounting of removable media is disabled': 1,
    'ensure gdm autorun-never is enabled': 1,
    'ensure gdm autorun-never is not overridden': 1,
    'ensure gdm disable-user-list option is enabled': 1,
    'ensure gdm disabling automatic mounting of removable media is not overridden': 1,
    'ensure gdm is removed': 2,
    'ensure gdm login banner is configured': 1,
    'ensure gdm screen locks cannot be overridden': 1,
    'ensure gdm screen locks when the user is idle': 1,
    'ensure gpg keys are configured': 1,
    'ensure group root is the only gid 0 group': 1,
    'ensure hfs kernel module is not available': 1,
    'ensure hfsplus kernel module is not available': 1,
    'ensure icmp redirects are not accepted': 1,
    'ensure inactive password lock is configured': 1,
    'ensure ip forwarding is disabled': 1,
    'ensure ip6tables default deny firewall policy': 1,
    'ensure ip6tables firewall rules exist for all open ports': 1,
    'ensure ip6tables loopback traffic is configured': 1,
    'ensure ip6tables outbound and established connections are configured': 1,
    'ensure iptables are flushed with nftables': 1,
    'ensure iptables default deny firewall policy': 1,
    'ensure iptables firewall rules exist for all open ports': 1,
    'ensure iptables loopback traffic is configured': 1,
    'ensure iptables outbound and established connections are configured': 1,
    'ensure iptables packages are installed': 1,
    'ensure iptables-persistent is not installed with ufw': 1,
    'ensure ipv6 router advertisements are not accepted': 1,
    'ensure ipv6 status is identified': 1,
    'ensure jffs2 kernel module is not available': 1,
    'ensure journald compress is configured': 1,
    'ensure journald forwardtosyslog is disabled': 1,
    'ensure journald is configured to send logs to rsyslog': 1,
    'ensure journald log file access is configured': 1,
    'ensure journald log file rotation is configured': 1,
    'ensure journald service is enabled and active': 1,
    'ensure journald storage is configured': 1,
    'ensure kernel module loading unloading and modification is collected': 2,
    'ensure latest version of pam is installed': 1,
    'ensure ldap client is not installed': 1,
    'ensure ldap server services are not in use': 1,
    'ensure libpam-modules is installed': 1,
    'ensure libpam-pwquality is installed': 1,
    'ensure local interactive user dot files access is configured': 1,
    'ensure local interactive user home directories are configured': 1,
    'ensure local login warning banner is configured properly': 1,
    'ensure login and logout events are collected': 2,
    'ensure logrotate is configured': 1,
    'ensure mail transfer agent is configured for local-only mode': 1,
    'ensure message access server services are not in use': 1,
    'ensure message of the day is configured properly': 1,
    'ensure minimum password age is configured': 2,
    'ensure minimum password days is configured': 2,
    'ensure minimum password length is configured': 1,
    'ensure network file system services are not in use': 1,
    'ensure nftables base chains exist': 1,
    'ensure nftables default deny firewall policy': 1,
    'ensure nftables is installed': 1,
    'ensure nftables is not in use with iptables': 1,
    'ensure nftables is not installed with iptables': 1,
    'ensure nftables loopback traffic is configured': 1,
    'ensure nftables outbound and established connections are configured': 1,
    'ensure nftables rules are permanent': 1,
    'ensure nftables service is enabled': 1,
    'ensure nis client is not installed': 1,
    'ensure nis server services are not in use': 1,
    'ensure no duplicate gids exist': 1,
    'ensure no duplicate group names exist': 1,
    'ensure no duplicate uids exist': 1,
    'ensure no duplicate user names exist': 1,
    'ensure no files or directories without an owner and a group exist': 1,
    'ensure nodev option set on /dev/shm partition': 1,
    'ensure nodev option set on /home partition': 1,
    'ensure nodev option set on /tmp partition': 1,
    'ensure nodev option set on /var partition': 1,
    'ensure nodev option set on /var/log partition': 1,
    'ensure nodev option set on /var/log/audit partition': 1,
    'ensure nodev option set on /var/tmp partition': 1,
    'ensure noexec option set on /dev/shm partition': 1,
    'ensure noexec option set on /tmp partition': 1,
    'ensure noexec option set on /var/log partition': 1,
    'ensure noexec option set on /var/log/audit partition': 1,
    'ensure noexec option set on /var/tmp partition': 1,
    'ensure nologin is not listed in /etc/shells': 2,
    'ensure nosuid option set on /dev/shm partition': 1,
    'ensure nosuid option set on /home partition': 1,
    'ensure nosuid option set on /tmp partition': 1,
    'ensure nosuid option set on /var partition': 1,
    'ensure nosuid option set on /var/log partition': 1,
    'ensure nosuid option set on /var/log/audit partition': 1,
    'ensure nosuid option set on /var/tmp partition': 1,
    'ensure only approved services are listening on a network interface': 1,
    'ensure only one logging system is in use': 1,
    'ensure overlayfs kernel module is not available': 2,
    'ensure package manager repositories are configured': 1,
    'ensure packet redirect sending is disabled': 1,
    'ensure pam_faillock module is enabled': 1,
    'ensure pam_pwhistory includes use_authtok': 1,
    'ensure pam_pwhistory module is enabled': 1,
    'ensure pam_pwquality module is enabled': 1,
    'ensure pam_unix does not include nullok': 1,
    'ensure pam_unix does not include remember': 1,
    'ensure pam_unix includes a strong password hashing algorithm': 1,
    'ensure pam_unix includes use_authtok': 1,
    'ensure pam_unix module is enabled': 1,
    'ensure password complexity is configured': 1,
    'ensure password dictionary check is enabled': 1,
    'ensure password expiration is configured': 1,
    'ensure password expiration warning days is configured': 1,
    'ensure password failed attempts lockout includes root account': 2,
    'ensure password failed attempts lockout is configured': 1,
    'ensure password history is enforced for the root user': 1,
    'ensure password history remember is configured': 1,
    'ensure password maximum sequential characters is configured': 1,
    'ensure password number of changed characters is configured': 1,
    'ensure password quality checking is enforced': 1,
    'ensure password quality is enforced for the root user': 1,
    'ensure password same consecutive characters is configured': 1,
    'ensure password unlock time is configured': 1,
    'ensure permissions on /etc/cron.d are configured': 1,
    'ensure permissions on /etc/cron.daily are configured': 1,
    'ensure permissions on /etc/cron.hourly are configured': 1,
    'ensure permissions on /etc/cron.monthly are configured': 1,
    'ensure permissions on /etc/cron.weekly are configured': 1,
    'ensure permissions on /etc/crontab are configured': 1,
    'ensure permissions on /etc/group are configured': 1,
    'ensure permissions on /etc/group- are configured': 1,
    'ensure permissions on /etc/gshadow are configured': 1,
    'ensure permissions on /etc/gshadow- are configured': 1,
    'ensure permissions on /etc/passwd are configured': 1,
    'ensure permissions on /etc/passwd- are configured': 1,
    'ensure permissions on /etc/security/opasswd are configured': 1,
    'ensure permissions on /etc/shadow are configured': 1,
    'ensure permissions on /etc/shadow- are configured': 1,
    'ensure permissions on /etc/shells are configured': 1,
    'ensure permissions on /etc/ssh/sshd_config are configured': 1,
    'ensure permissions on ssh private host key files are configured': 1,
    'ensure permissions on ssh public host key files are configured': 1,
    'ensure prelink is not installed': 1,
    'ensure print server services are not in use': 1,
    'ensure ptrace_scope is restricted': 1,
    'ensure rds kernel module is not available': 2,
    'ensure re-authentication for privilege escalation is not disabled globally': 1,
    'ensure remote login warning banner is configured properly': 1,
    'ensure reverse path filtering is enabled': 1,
    'ensure root account access is controlled': 1,
    'ensure root is the only gid 0 account': 1,
    'ensure root is the only uid 0 account': 1,
    'ensure root password is set': 1,
    'ensure root path integrity': 1,
    'ensure root user umask is configured': 1,
    'ensure rpcbind services are not in use': 1,
    'ensure rsh client is not installed': 1,
    'ensure rsync services are not in use': 1,
    'ensure rsyslog is configured to send logs to a remote log host': 1,
    'ensure rsyslog is installed': 1,
    'ensure rsyslog is not configured to receive logs from a remote client': 1,
    'ensure rsyslog log file creation mode is configured': 1,
    'ensure rsyslog logging is configured': 1,
    'ensure rsyslog service is enabled and active': 1,
    'ensure samba file server services are not in use': 1,
    'ensure sctp kernel module is not available': 2,
    'ensure secure icmp redirects are not accepted': 1,
    'ensure separate partition exists for /home': 2,
    'ensure separate partition exists for /var': 2,
    'ensure separate partition exists for /var/log': 2,
    'ensure separate partition exists for /var/log/audit': 2,
    'ensure separate partition exists for /var/tmp': 2,
    'ensure session initiation information is collected': 2,
    'ensure shadow group is empty': 1,
    'ensure snmp services are not in use': 1,
    'ensure source routed packets are not accepted': 1,
    'ensure squashfs kernel module is not available': 2,
    'ensure sshd access is configured': 1,
    'ensure sshd banner is configured': 1,
    'ensure sshd ciphers are configured': 1,
    'ensure sshd clientaliveinterval and clientalivecountmax are configured': 1,
    'ensure sshd disableforwarding is enabled': 2,
    'ensure sshd gssapiauthentication is disabled': 2,
    'ensure sshd hostbasedauthentication is disabled': 1,
    'ensure sshd ignorerhosts is enabled': 1,
    'ensure sshd kexalgorithms is configured': 1,
    'ensure sshd logingracetime is configured': 1,
    'ensure sshd loglevel is configured': 1,
    'ensure sshd macs are configured': 1,
    'ensure sshd maxauthtries is configured': 1,
    'ensure sshd maxsessions is configured': 1,
    'ensure sshd maxstartups is configured': 1,
    'ensure sshd permitemptypasswords is disabled': 1,
    'ensure sshd permitrootlogin is disabled': 1,
    'ensure sshd permituserenvironment is disabled': 1,
    'ensure sshd usepam is enabled': 1,
    'ensure strong password hashing algorithm is configured': 1,
    'ensure successful and unsuccessful attempts to use the chacl command are collected': 2,
    'ensure successful and unsuccessful attempts to use the chacl command are recorded': 2,
    'ensure successful and unsuccessful attempts to use the chcon command are collected': 2,
    'ensure successful and unsuccessful attempts to use the chcon command are recorded': 2,
    'ensure successful and unsuccessful attempts to use the setfacl command are collected': 2,
    'ensure successful and unsuccessful attempts to use the setfacl command are recorded': 2,
    'ensure successful and unsuccessful attempts to use the usermod command are collected': 2,
    'ensure successful and unsuccessful attempts to use the usermod command are recorded': 2,
    'ensure successful file system mounts are collected': 2,
    'ensure sudo authentication timeout is configured correctly': 1,
    'ensure sudo commands use pty': 1,
    'ensure sudo is installed': 1,
    'ensure sudo log file exists': 1,
    'ensure suid and sgid files are reviewed': 1,
    'ensure suspicious packets are logged': 1,
    'ensure system accounts do not have a valid login shell': 1,
    'ensure system is disabled when audit logs are full': 2,
    'ensure system warns when audit logs are low on space': 2,
    'ensure systemd-journal-remote authentication is configured': 1,
    'ensure systemd-journal-remote is installed': 1,
    'ensure systemd-journal-remote service is not in use': 1,
    'ensure systemd-journal-upload authentication is configured': 1,
    'ensure systemd-journal-upload is enabled and active': 1,
    'ensure systemd-timesyncd configured with authorized timeserver': 1,
    'ensure systemd-timesyncd is enabled and running': 1,
    'ensure talk client is not installed': 1,
    'ensure tcp syn cookies is enabled': 1,
    'ensure telnet client is not installed': 1,
    'ensure tftp server services are not in use': 1,
    'ensure the audit configuration is immutable': 2,
    'ensure the audit log file directory mode is configured': 2,
    'ensure the running and on disk configuration is the same': 2,
    'ensure tipc kernel module is not available': 2,
    'ensure udf kernel module is not available': 2,
    'ensure ufw default deny firewall policy': 1,
    'ensure ufw firewall rules exist for all open ports': 1,
    'ensure ufw is installed': 1,
    'ensure ufw is not in use with iptables': 1,
    'ensure ufw is uninstalled or disabled with iptables': 1,
    'ensure ufw is uninstalled or disabled with nftables': 1,
    'ensure ufw loopback traffic is configured': 1,
    'ensure ufw outbound connections are configured': 1,
    'ensure ufw service is enabled': 1,
    'ensure unsuccessful file access attempts are collected': 2,
    'ensure unused filesystems kernel modules are not available': 1,
    'ensure updates, patches, and additional security software are installed': 1,
    'ensure usb-storage kernel module is not available': 1,
    'ensure use of privileged commands are collected': 2,
    'ensure users must provide password for privilege escalation': 2,
    'ensure web proxy server services are not in use': 1,
    'ensure web server services are not in use': 1,
    'ensure wireless interfaces are disabled': 1,
    'ensure world writable files and directories are secured': 1,
    'ensure x window server services are not in use': 2,
    'ensure xdmcp is not enabled': 1,
    'ensure xinetd services are not in use': 1,
};
//# sourceMappingURL=cis-levels.data.js.map